var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEm100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.7,5.65c-.73-.51-1.73-.34-2.24.39-.51.73-.34,1.73.39,2.24,2.71,1.91,4.33,5.02,4.33,8.33,0,5.61-4.57,10.18-10.18,10.18s-10.18-4.57-10.18-10.18c0-3.31,1.62-6.42,4.33-8.33.73-.51.9-1.51.39-2.24-.51-.73-1.51-.9-2.24-.39-3.56,2.51-5.69,6.6-5.69,10.96,0,7.38,6.01,13.39,13.39,13.39s13.39-6.01,13.39-13.39c0-4.35-2.13-8.45-5.69-10.96Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15,18.21c.89,0,1.61-.72,1.61-1.61V1.61c0-.89-.72-1.61-1.61-1.61s-1.61.72-1.61,1.61v15c0,.89.72,1.61,1.61,1.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEm100);
export default __webpack_public_path__ + "static/media/EM100.9279c363573102c11e69586ae2913ba4.svg";
export { ForwardRef as ReactComponent };